var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3266 15.0784C10.2099 15.1952 10.0433 15.2475 9.88076 15.2183C9.71813 15.1892 9.5801 15.0823 9.51126 14.932L7.02247 9.50758C6.94777 9.34483 6.96498 9.1548 7.06754 9.00811L8.91393 6.36922L6.28744 8.22459C6.21509 8.27576 6.13067 8.30702 6.04239 8.31509C5.95423 8.32317 5.86548 8.30795 5.78505 8.27072L0.340194 5.76119C0.217024 5.70441 0.121837 5.60044 0.0762933 5.47259C0.0306328 5.34485 0.0383598 5.20412 0.0978362 5.08213C0.157197 4.96013 0.263271 4.86717 0.391944 4.82432L14.5196 0.115596C14.6386 0.076023 14.7681 0.0822274 14.8828 0.133041C14.9974 0.183854 15.0891 0.275529 15.1399 0.39015C15.1907 0.504889 15.1969 0.634381 15.1573 0.75333L10.4486 14.8813C10.4239 14.9556 10.3822 15.0232 10.3267 15.0785L10.3266 15.0784Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/PaperPlane.0f733613c39a13f3a1067bb5a637ac4d.svg";
export { ForwardRef as ReactComponent };